/* ============================================================
   BABYGO list popup
   Any button or link with data-bg-list="<klaviyo list id>" opens a
   bottom sheet that takes an email and subscribes it to that list
   through Klaviyo's client endpoint (public company id only), with
   properties saying what was signed up to and on which page.
   Optional attributes on the trigger:
     data-bg-list-name   what they are signing up to (goes to Klaviyo)
     data-bg-list-title  heading in the sheet
     data-bg-list-sub    one line under the heading
     data-bg-list-image  picture at the top (left on desktop)
     data-bg-list-cta    button text (defaults to the trigger's text)
     data-bg-list-topic  Klaviyo signup_topic (safety_blog, baby_blog, postnatal_blog, pregnancy_blog); falls back to [data-signup-topic] on the page
   Without JS the trigger is a normal link to the sign-up page.
   Namespaced .bgl-; does not touch fyb.js or klaviyo-submit.js.
   Blog articles (25 Sep 2026): the page provides <dialog data-bgl-sheet>
   (sections/main-article.liquid). There the sheet is the product page
   pattern: bg-pdp.js opens and closes the dialog ([data-pdp-dialog-open]
   is added to each trigger below) and this file fills it and sends it,
   with the same list, checks, consent line and tracking. Pages without
   that dialog keep the bottom sheet built here.
   ============================================================ */
(function (w, d) {
  'use strict';

  var CFG = {
    siteId: 'T3r2Jy',
    revision: '2025-10-15',
    defaultList: 'Xn4Z3i',
    defaultImage: 'https://cdn.shopify.com/s/files/1/0012/5137/7230/files/login-image-4-centered.jpg?v=1789485053&width=1200',
    minFillMs: 900
  };
  var rx = /^[^\s@]+@[^\s@]{1,}\.[^\s@]{2,}$/i;
  var EMAIL_KEY = 'bgl_email';
  var root = null, el = {}, current = null, lastFocus = null, openedAt = 0, closeTimer = null;
  var sheet = null; /* the page's <dialog data-bgl-sheet>, when there is one */

  function track(ev, extra) {
    var o = { event: ev }; if (extra) for (var k in extra) o[k] = extra[k];
    try { w.dataLayer = w.dataLayer || []; w.dataLayer.push(o); } catch (e) {}
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish(ev, extra || {});
    } catch (e) {}
  }
  function getEmail() { try { return sessionStorage.getItem(EMAIL_KEY) || ''; } catch (e) { return ''; } }
  function setEmail(v) { try { sessionStorage.setItem(EMAIL_KEY, v); } catch (e) {} }

  /* ---------- Klaviyo ---------- */
  function subscribe(email, listId, props) {
    var body = { data: {
      type: 'subscription',
      attributes: {
        custom_source: 'BABYGO list: ' + (props.list_signup || 'blog'),
        profile: { data: { type: 'profile', attributes: {
          email: String(email).trim(),
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
          properties: props
        } } }
      },
      relationships: { list: { data: { type: 'list', id: listId } } }
    } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.siteId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': CFG.revision },
      body: JSON.stringify(body)
    });
  }

  /* ---------- sheet ---------- */
  function build() {
    root = d.createElement('div');
    root.className = 'bgl-root';
    root.id = 'bgl-root';
    root.hidden = true;
    root.innerHTML =
      '<div class="bgl-scrim" data-bgl-close aria-hidden="true"></div>' +
      '<div class="bgl-panel" role="dialog" aria-modal="true" aria-labelledby="bgl-h">' +
        '<button type="button" class="bgl-x" data-bgl-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="bgl-grid">' +
          '<img class="bgl-img" alt="" width="1200" height="675">' +
          '<div class="bgl-body">' +
            '<p class="bgl-eyebrow">BABYGO&reg; list</p>' +
            '<div class="bgl-ask">' +
              '<h2 class="bgl-h" id="bgl-h"></h2>' +
              '<p class="bgl-sub"></p>' +
            '</div>' +
            '<form class="bgl-form" novalidate>' +
              '<label class="bgl-hp" aria-hidden="true">Leave this empty<input type="text" name="bgl_extra_field" tabindex="-1" autocomplete="off"></label>' +
              '<label class="bgl-hp" for="bgl-email">Email address</label>' +
              '<input class="bgl-input" id="bgl-email" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com" required>' +
              '<p class="bgl-error" aria-live="polite"></p>' +
              '<button type="submit" class="bgl-cta"></button>' +
            '</form>' +
            '<p class="bgl-legal">By signing up you&rsquo;ll receive marketing emails from BABYGO&reg;. We never share your details and you can unsubscribe anytime. <a href="/policies/privacy-policy">Privacy policy</a></p>' +
            '<div class="bgl-done">' +
              '<svg class="bgl-ring" viewBox="0 0 66 66" aria-hidden="true"><circle cx="33" cy="33" r="31"/><path d="M21 34.5l8.5 8.5L46 26"/></svg>' +
              '<h2 class="bgl-h">On its way</h2>' +
              '<p class="bgl-sub"></p>' +
              '<button type="button" class="bgl-cta" data-bgl-close>Back to the guide</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    d.body.appendChild(root);
    el.panel = root.querySelector('.bgl-panel');
    el.img = root.querySelector('.bgl-img');
    el.h = root.querySelector('.bgl-ask .bgl-h');
    el.sub = root.querySelector('.bgl-ask .bgl-sub');
    el.form = root.querySelector('.bgl-form');
    el.email = root.querySelector('#bgl-email');
    el.hp = root.querySelector('[name="bgl_extra_field"]');
    el.err = root.querySelector('.bgl-error');
    el.cta = root.querySelector('.bgl-form .bgl-cta');
    el.doneSub = root.querySelector('.bgl-done .bgl-sub');

    root.addEventListener('click', function (e) { if (e.target.closest('[data-bgl-close]')) close(); });
    el.form.addEventListener('submit', submit);
    el.email.addEventListener('input', function () { root.classList.remove('bgl-err'); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('bgl-open')) close(); });
  }

  /* ---------- blog article sheet (dialog) ---------- */
  function findSheet() {
    var s = d.querySelector('dialog[data-bgl-sheet]');
    if (!s || typeof s.showModal !== 'function' || !w.__bgPdp) return null;
    return s;
  }
  function buildSheet() {
    var box = sheet.querySelector('[data-bgl-sheet-content]') || sheet;
    var note = sheet.getAttribute('data-bgl-note') || '';
    box.innerHTML =
      '<div class="bgl-ask">' +
        '<h2 class="bgl-h" id="bgl-sheet-h"></h2>' +
        '<p class="bgl-sub"></p>' +
      '</div>' +
      '<form class="bgl-form" novalidate>' +
        '<label class="bgl-hp" aria-hidden="true">Leave this empty<input type="text" name="bgl_extra_field" tabindex="-1" autocomplete="off"></label>' +
        '<label class="bgl-hp" for="bgl-sheet-email">Email address</label>' +
        '<input class="bgl-input" id="bgl-sheet-email" type="email" inputmode="email" autocomplete="email" placeholder="Email address" required aria-describedby="bgl-sheet-error">' +
        '<p class="bgl-error" id="bgl-sheet-error" aria-live="polite"></p>' +
        '<button type="submit" class="bgl-cta"></button>' +
      '</form>' +
      (note ? '<p class="bgl-note"></p>' : '') +
      '<p class="bgl-legal">By signing up you&rsquo;ll receive marketing emails from BABYGO&reg;. We never share your details and you can unsubscribe anytime. <a href="/policies/privacy-policy">Privacy policy</a></p>' +
      '<div class="bgl-done">' +
        '<h2 class="bgl-h" tabindex="-1">On its way</h2>' +
        '<p class="bgl-sub"></p>' +
        '<button type="button" class="bgl-cta" data-pdp-dialog-close>Back to the guide</button>' +
      '</div>';
    if (note) box.querySelector('.bgl-note').textContent = note;
    root = sheet;
    el.panel = sheet.querySelector('.bgp-sheet__panel') || sheet;
    el.img = null;
    el.h = box.querySelector('.bgl-ask .bgl-h');
    el.sub = box.querySelector('.bgl-ask .bgl-sub');
    el.form = box.querySelector('.bgl-form');
    el.email = box.querySelector('#bgl-sheet-email');
    el.hp = box.querySelector('[name="bgl_extra_field"]');
    el.err = box.querySelector('.bgl-error');
    el.cta = box.querySelector('.bgl-form .bgl-cta');
    el.doneH = box.querySelector('.bgl-done .bgl-h');
    el.doneSub = box.querySelector('.bgl-done .bgl-sub');
    el.form.addEventListener('submit', submit);
    el.email.addEventListener('input', function () { root.classList.remove('bgl-err'); });
    /* bg-pdp.js opens the dialog from the trigger itself, like every other product page sheet. */
    var triggers = d.querySelectorAll('[data-bg-list]');
    for (var i = 0; i < triggers.length; i++) {
      if (!triggers[i].hasAttribute('data-pdp-dialog-open')) triggers[i].setAttribute('data-pdp-dialog-open', sheet.id);
      triggers[i].setAttribute('aria-haspopup', 'dialog');
    }
  }

  function topicFromPage() {
    var el = d.querySelector('[data-signup-topic]');
    return (el && el.getAttribute('data-signup-topic')) || 'blog';
  }
  /* GA4 params for bg_list_open / bg_list_signup (via the 'GA4 - Follow Your Bump' custom pixel, 29 Oct 2026) */
  function listParams() {
    return { list_id: current.listId, list_name: current.name, topic: current.topic || topicFromPage(), page: location.pathname };
  }
  function fill(trigger) {
    var ds = trigger.dataset;
    var name = ds.bgListName || 'the BABYGO list';
    current = {
      listId: ds.bgList || CFG.defaultList,
      name: name,
      cta: ds.bgListCta || (trigger.textContent || '').trim() || 'Send it to me',
      topic: ds.bgListTopic || ''
    };
    if (el.img) el.img.src = ds.bgListImage || CFG.defaultImage;
    el.h.textContent = ds.bgListTitle || 'Where should we send it?';
    el.sub.textContent = ds.bgListSub || (name.charAt(0).toUpperCase() + name.slice(1) + ', straight to your inbox. Plus 10% off when you’re ready.');
    el.cta.textContent = current.cta;
    el.cta.disabled = false;
    el.doneSub.textContent = 'Check your inbox in the next few minutes, and the junk folder the first time.';
    el.email.value = getEmail();
    el.hp.value = '';
    root.classList.remove('bgl-ok', 'bgl-err');
  }

  function open(trigger) {
    if (sheet) {
      fill(trigger);
      if (!sheet.open) { try { sheet.showModal(); } catch (e) {} }
      openedAt = Date.now();
      setTimeout(function () { try { if (!el.email.value) el.email.focus({ preventScroll: true }); } catch (e) {} }, 360);
      track('bg_list_open', listParams());
      return;
    }
    if (!root) build();
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; root.classList.remove('bgl-closing'); }
    fill(trigger);
    lastFocus = d.activeElement;
    root.hidden = false;
    d.body.classList.add('bgl-lock');
    openedAt = Date.now();
    w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { root.classList.add('bgl-open'); }); });
    setTimeout(function () { try { if (!el.email.value) el.email.focus({ preventScroll: true }); } catch (e) {} }, 360);
    track('bg_list_open', listParams());
  }

  function close() {
    if (sheet) { if (sheet.open) sheet.close(); return; }
    if (!root || root.hidden) return;
    root.classList.remove('bgl-open');
    root.classList.add('bgl-closing');
    d.body.classList.remove('bgl-lock');
    closeTimer = setTimeout(function () {
      root.classList.remove('bgl-closing');
      root.hidden = true;
      closeTimer = null;
      try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }, 240);
  }

  function fail(msg) {
    el.err.textContent = msg;
    root.classList.add('bgl-err');
    el.cta.disabled = false;
    el.cta.textContent = current.cta;
    try { el.email.focus({ preventScroll: true }); } catch (e) {}
  }

  function submit(e) {
    e.preventDefault();
    if (!current || el.cta.disabled) return;
    var email = (el.email.value || '').trim();
    if (el.hp.value) { root.classList.add('bgl-ok'); return; }           /* honeypot filled: pretend */
    if (Date.now() - openedAt < CFG.minFillMs) { fail('One second, then try again.'); return; }
    if (!rx.test(email)) { fail('That email doesn’t look right. Check it and try again.'); return; }
    el.cta.disabled = true;
    el.cta.textContent = 'Sending…';
    root.classList.remove('bgl-err');
    var props = {
      signup_source: 'blog_list',
      list_signup: current.name,
      signup_page: location.pathname,
      signup_title: (d.title || '').replace(/\s+/g, ' ').trim(),
      signup_date: new Date().toISOString().slice(0, 10),
      signup_topic: current.topic || topicFromPage()   /* safety_blog, baby_blog, postnatal_blog, pregnancy_blog (Gavin, 27 Sep 2026) */
    };
    subscribe(email, current.listId, props).then(function (res) {
      if (res.ok || res.status === 409) {
        setEmail(email);
        root.classList.add('bgl-ok');
        try { el.panel.scrollTop = 0; } catch (e2) {}
        if (sheet && el.doneH) { try { el.doneH.focus({ preventScroll: true }); } catch (e3) {} }
        track('bg_list_signup', listParams());
      } else {
        fail('That didn’t send. Check the address and try again.');
      }
    }).catch(function () {
      fail('No connection just now. Try again in a moment.');
    });
  }

  sheet = findSheet();
  if (sheet) buildSheet();

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bg-list]');
    if (!t) return;
    e.preventDefault();
    open(t);
  });
})(window, document);
